import { render, staticRenderFns } from "./salesOrderHistoryMXInfo.vue?vue&type=template&id=17b95d03&scoped=true"
import script from "./salesOrderHistoryMXInfo.vue?vue&type=script&lang=js"
export * from "./salesOrderHistoryMXInfo.vue?vue&type=script&lang=js"
import style0 from "./salesOrderHistoryMXInfo.vue?vue&type=style&index=0&id=17b95d03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b95d03",
  null
  
)

export default component.exports